export const useGetCurrentLocation = () => {
  const currentLocation = {
    name: '2700 East Coast Hwy, Corona Del Mar, CA',
    lat: 33.602508,
    long: -117.872654,
  };
  return { currentLocation };
};
